import { render } from "./NavMenus.vue?vue&type=template&id=54bfb8bf&scoped=true&ts=true"
import script from "./NavMenus.vue?vue&type=script&lang=ts"
export * from "./NavMenus.vue?vue&type=script&lang=ts"

import "./NavMenus.vue?vue&type=style&index=0&id=54bfb8bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bfb8bf"]])

export default __exports__